export enum OnixGenerationModalStatus {
  IDLE = "IDLE",
  REQUESTED = "REQUESTED",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}
